import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  AddressDialog,
  AddressDialogCallbackInput,
  AddressUniqueProps,
} from '../AddressDialog';

const { useDialogForContext, useDialog: useAddressDialog } = getDialogHooks<
  AddressUniqueProps,
  AddressDialogCallbackInput
>(AddressDialog);
export const useAddressDialogForContext = useDialogForContext;
export default useAddressDialog;
